
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7fce3caa&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SegmentButtons.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SegmentButtons.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7fce3caa!../../../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SegmentButtons.vue"),
  /* scopeId */
  "data-v-7fce3caa",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/structure/ui/actions/SegmentButtons.vue
// module id = 2064
// module chunks = 1